import { useEffect, useState } from "react";

const useCheckVersion = () => {
    const [version, setVersion] = useState<string | null>(null);

    useEffect(() => {
        const checkVersion = async () => {
            if(process.env.REACT_APP_ENV === 'local') return;
            try {
                const response = await fetch("/version.json", { cache: "no-store" });
                const data = await response.json();

                const storedVersion = localStorage.getItem("brand_app_version");

                if (!storedVersion) {
                    localStorage.setItem("brand_app_version", data.version);
                    setVersion(data.version);
                } else if (storedVersion !== data.version) {
                    localStorage.setItem("brand_app_version", data.version);
                    window.location.reload(); // Force refresh on new build
                }
            } catch (error) {
                console.error("Error checking app version:", error);
            }
        };

        checkVersion();
        const interval = setInterval(checkVersion, 30000); // Check every 30 seconds

        return () => clearInterval(interval);
    }, []);

    return version;
};

export default useCheckVersion;